import {useEffect, useState} from "react";

const validateInput = (value) => {
    const regex = /^(?!0$)(?!1[!X?+\-]*$)(?!.*[+\-]).*$/;
    return regex.test(value)
};

const InputItemParticipation = ({entry, projectID, instrument, ChangeDBHandler}) => {
    const [valState, setValState] = useState("");

    useEffect(() => {
        setValState(entry.participation[projectID]?.status || "")
    }, [entry.participation])

    const changeHandler = (newValue) => {
        if (!validateInput(newValue)) return;

        const is_entry = Object.keys(entry.participation).length > 0 && entry.participation[projectID]
        if (is_entry && entry.participation[projectID].is_filled_form) return // jezeli wypelniono w formularzu szczegolow

        setValState(newValue)
    }

    console.log("reload...")

    return (
        <input
            value={valState}
            onBlur={(val) =>
                ChangeDBHandler(val.target.value, projectID, entry.user_id, instrument, undefined, false)
            }
            onChange={(val) => changeHandler(val.target.value)}
            name="participation-entry"
            type="text"
            style={{ maxWidth: '58px', textAlign: 'center' }}
            readOnly={entry.participation[projectID]?.is_filled_form}
        />
    )
}

export default InputItemParticipation

